export default __webpack_public_path__ + "static/media/10.785ddf05.webp";